export const mainSkills: string[] = [
  "TypeScript",
  "JavaScript",
  "React",
  "Node",
  "Next",
  "Native",
  "Python",
  "HTML",
  "CSS",
  "SQL",
  "Git",
];

export const mainTools: string[] = [
  "Tailwind CSS",
  "Docker",
  "AWS",
  "PostgreSQL",
  "Supabase",
  "Vercel",
  "Drip",
  "Figma",
];
